export const fixedRanges = {
    combinedProduct: {
        SOS: { min: 95, max: 125 },
        LOS: { min: 155, max: 205 },
        EOS: { min: 275, max: 310 },
    },
    dpz: {
        SOS: { min: 95, max: 125 },
        LOS: { min: 165, max: 220 },
        EOS: { min: 285, max: 325 },
    }
};